"use client"

import { getTheme } from "@/theme"
import { SxProps, Theme, Typography, TypographyProps } from "@mui/material"
import { PropsWithChildren } from "react"

export const Blockquote = ({ children, sx = {}, ...props }: PropsWithChildren<TypographyProps>) => {
    const style = { ...styles, ...sx }
    return (
        <Typography component="blockquote" {...props} sx={style}>
            {children}
        </Typography>
    )
}

const theme = getTheme()

const styles: SxProps<Theme> = {
    mb: 2,
    borderLeft: `3px solid ${theme.palette.primary.dark}`,
    pl: 2,
}
